import type { StripePerson } from '@klear/stripe'

export type KycPersonView = {
  id?: string
  firstName: string
  lastName: string
  verificationStatus?: string
  errors: { reason: string }[]
  currentlyDue: string[]
  alternatives: { originalFieldsDue: string[]; alternativeFieldsDue: string[] }[]
  hasOutstandingRequirements: boolean
}

export function kycPersonViewFromStripe(person: StripePerson): KycPersonView {
  const currentlyDue = person.requirements?.currently_due ?? []
  const errors = (person.requirements?.errors ?? []).map((error) => ({ reason: error.reason ?? '' }))
  const alternatives = (person.requirements?.alternatives ?? []).map((alt) => ({
    originalFieldsDue: alt?.original_fields_due ?? [],
    alternativeFieldsDue: alt?.alternative_fields_due ?? []
  }))

  return {
    id: person.id,
    firstName: person.first_name ?? '',
    lastName: person.last_name ?? '',
    verificationStatus: person.verification?.status,
    errors,
    currentlyDue,
    alternatives,
    hasOutstandingRequirements: currentlyDue.length > 0 || errors.length > 0
  }
}

export function kycPersonViewsFromStripe(persons: StripePerson[]): KycPersonView[] {
  return persons.map(kycPersonViewFromStripe)
}
